<div class="p-fluid p-4">
  <h2 class="text-lg font-semibold mb-4 border-b pb-2">Change Crystal Report</h2>

  <!-- File Upload -->
  <p-fileUpload
    name="crystalReport"
    mode="basic"
    [url]="AppConsts.remoteServiceBaseUrl + '/File/UploadCrystalReport?filepath=' + uploadedFileName"
    accept=".rpt"
    auto="true"
    maxFileSize="5242880"
    chooseLabel="Upload Report"
    (onUpload)="onUpload($event)"
    class="p-button-outlined p-button-primary"
  ></p-fileUpload>

  <small class="text-muted d-block mt-2 text-sm"
    >Only <code>.rpt</code> files are allowed.</small
  >

  <input
    type="text"
    class="p-inputtext p-component mt-4 w-full"
    [value]="uploadedFileName"
    disabled
  />

  <!-- Footer Buttons -->
<div class="flex flex-wrap justify-end gap-3 mt-5 border-t pt-3">
  <button
    pButton
    label="Download Current Format"
    icon="pi pi-download"
    class="p-button-outlined p-button-secondary"
    (click)="download()"
  ></button>

  <button
    pButton
    label="Default Crystal Report"
    icon="pi pi-refresh"
    class="p-button-outlined p-button-warning"
    *ngIf="uploadedFileName"
    (click)="clearReport()"
  ></button>

  <button
    pButton
    label="Cancel"
    icon="pi pi-times"
    class="p-button-outlined p-button-secondary"
    (click)="cancel()"
  ></button>

  <button
    pButton
    label="Save"
    icon="pi pi-save"
    class="p-button p-button-primary"
    [disabled]="saveButtonDisabled"
    (click)="save()"
  ></button>
</div>

</div>
